import {withNamespaces, WithNamespaces} from 'react-i18next'
import {Members as MembersPresentation} from './members'

export interface MembersProps extends WithNamespaces {
  event: ExtendedEvent
}

export const Members = withNamespaces()(MembersPresentation)
